import { defineStore } from 'pinia'
import { expectObject } from '../composables/expectShape'
import { useAsyncResource, UnauthorizedError } from '../composables/useAsyncResource'

export interface AgentSessionSlotUsage {
  in_use: number
  capacity: number
}

// Global agent-session devcontainer slot pool usage (#1352/#1353) — read-only,
// no mutations, mirroring useAgentHostStatsStore's fetch/loading/error shape.
export const useAgentSessionSlotsStore = defineStore('agentSessionSlots', () => {
  const {
    data: usage,
    loaded,
    loading,
    error: loadError,
    needsAuth,
    refresh: fetchUsage,
  } = useAsyncResource<AgentSessionSlotUsage>(async () => {
    const res = await fetch('/api/v1/agent/session_slots', { credentials: 'include' })
    if (res.status === 401) throw new UnauthorizedError()
    if (!res.ok) throw new Error(`Failed to load slot usage: ${res.status}`)
    return expectObject<AgentSessionSlotUsage>(await res.json(), 'slot usage')
  })

  return {
    usage,
    loading,
    loaded,
    needsAuth,
    loadError,
    fetchUsage,
  }
})
